import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import AzHispanic from '../AzHispanic/AzHispanic'
import AzSemi from '../AzSemi/AzSemi'
import OOSHispanic from '../OOSHispanic/OOSHispanic'
import OOSSemi from '../OOSSemi/OOSSemi'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Style from './AwardSection.css'

const AwardSection = (props) => {
  const [ref, inView] = useInView({
    threshold: 0.5,
  })

  useEffect(() => {
    if (inView) {
      props.setSection()
    }
  })

  return (
    <section ref={ref} className={`awards ${props.show}`}>
      <div className="container">
        <h2>YOUR TUITION AWARD</h2>
      </div>
      <div className="container">
        <div className="award-content">
          <Router>
            <Switch>
              <Route path="/awards/azscholar">
                <AzHispanic />
              </Route>
              <Route path="/awards/scholar">
                <OOSHispanic />
              </Route>
              <Route path="/awards/azmerit">
                <AzSemi />
              </Route>
              <Route path="/awards/merit">
                <OOSSemi />
              </Route>
              <Route path="/">
                <OOSSemi />
              </Route>
            </Switch>
          </Router>
          <a
            href="https://financialaid.arizona.edu/2025-2026-terms-and-conditions"
            target="_blank"
            rel="noopener"
            id="terms-and-conditions"
            className="terms"
          >
            Terms and conditions
          </a>
        </div>
      </div>
    </section>
  )
}

export default AwardSection
